'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require('semantic-ui-react');

var _number = require('./../number');

var _number2 = _interopRequireDefault(_number);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var totalStyles = {
  backgroundColor: 'rgba(0,0,0,.05)',
  fontWeight: 'bold'
};

var BasicReportTotalsRow = function BasicReportTotalsRow(_ref) {
  var assetCount = _ref.assetCount,
      totalReach = _ref.totalReach,
      totalImpressions = _ref.totalImpressions,
      totalLikes = _ref.totalLikes,
      totalComments = _ref.totalComments,
      totalShares = _ref.totalShares,
      totalViews = _ref.totalViews,
      withDeleteButton = _ref.withDeleteButton;
  return _react2.default.createElement(
    _semanticUiReact.Table.Row,
    { style: totalStyles },
    _react2.default.createElement(_semanticUiReact.Table.Cell, null),
    _react2.default.createElement(_semanticUiReact.Table.Cell, null),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(
        'span',
        null,
        'Totals (',
        assetCount,
        ' assets)'
      )
    ),
    _react2.default.createElement(_semanticUiReact.Table.Cell, null),
    _react2.default.createElement(_semanticUiReact.Table.Cell, null),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_number2.default, { number: totalViews, label: 'views' })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      totalReach && _react2.default.createElement(_number2.default, { number: totalReach, label: 'reach' })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      totalImpressions && _react2.default.createElement(_number2.default, { number: totalImpressions, label: 'impressions' })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_number2.default, { number: totalLikes, label: 'likes' })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_number2.default, { number: totalComments, label: 'comments' })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_number2.default, { number: totalShares, label: 'shares' })
    ),
    _react2.default.createElement(_semanticUiReact.Table.Cell, null),
    withDeleteButton && _react2.default.createElement(_semanticUiReact.Table.Cell, null)
  );
};

BasicReportTotalsRow.propTypes = {
  withDeleteButton: _propTypes2.default.bool,
  assetCount: _propTypes2.default.number.isRequired,
  totalReach: _propTypes2.default.number.isRequired,
  totalImpressions: _propTypes2.default.number.isRequired,
  totalLikes: _propTypes2.default.number.isRequired,
  totalComments: _propTypes2.default.number.isRequired,
  totalShares: _propTypes2.default.number.isRequired,
  totalViews: _propTypes2.default.number.isRequired
};

BasicReportTotalsRow.defaultProps = {
  withDeleteButton: false
};

exports.default = BasicReportTotalsRow;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/reports/basic-report-totals-row/index.js
 ** module id = 2611
 ** module chunks = 0
 **/